import { ChangeDetectionStrategy, Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ILightWeightUserWithUnits } from '@fi-shared/models';

@Component({
    selector: 'fi-chat-conversation-manage-users-add-more-container',
    template: `
        <div class="conversation-add-more-users-filter-container">
            <mat-form-field
                appearance="outline"
                class="mat-form-field-no-border-outline conversation-users-filter-input"
            >
                <mat-icon matPrefix class="conversation-search-input-icon fas fa-search"></mat-icon>
                <input
                    matInput
                    #searchInput
                    [placeholder]="'chat.search_colleagues_and_units' | fiAppText"
                    [(ngModel)]="filterValue"
                />
            </mat-form-field>
        </div>

        <fi-chat-conversation-users-list
            class="default-scroll-bar"
            [selectedUsers]="selectedUsers"
            [users]="getUsersWithUnits()"
            [isRippleEffect]="true"
            (onUserCardClick)="userCardClick($event)"
        >
        </fi-chat-conversation-users-list>
        <div
            class="conversation-manage-users-footer ContrastBackgroundColor"
            [ngClass]="{ disabled: isAddColleaguesButtonDisabled() }"
        ></div>
        <button
            mat-button
            class="conversation-remove-user-footer-button"
            [disabled]="isAddColleaguesButtonDisabled()"
            [ngClass]="{ ContrastColor: isAddColleaguesButtonDisabled() }"
            (click)="confirm()"
        >
            {{ 'chat.add_selected_members' | fiAppText }}
        </button>
    `,
    styleUrls: ['./fi-chat-conversation-manage-users-add-more-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-manage-users-add-more-container' },
    standalone: false,
})
export class FiChatConversationManageUsersAddMoreContainerComponent {
    @Input() users: ILightWeightUserWithUnits[] = [];
    @Input() selectedUsers: ILightWeightUserWithUnits[] = [];
    @Output() selectedUsersChange = new EventEmitter<ILightWeightUserWithUnits[]>();
    @Output() onConfirm = new EventEmitter();
    filterValue: string = '';

    confirm() {
        this.onConfirm.emit();
    }

    isAddColleaguesButtonDisabled(): boolean {
        return !this.selectedUsers.length;
    }

    getUsersWithUnits() {
        return this.users.filter((user) => {
            return (
                user.FullName.toLowerCase().includes(this.filterValue.toLowerCase()) ||
                user.BusinessUnits.some((unit) => unit.Name.toLowerCase().includes(this.filterValue.toLowerCase()))
            );
        });
    }

    userCardClick(user: ILightWeightUserWithUnits) {
        const userIdx = this.getUserIdIdx(user);
        if (userIdx === -1) {
            this.selectedUsers.push(user);
        } else {
            this.selectedUsers.splice(userIdx, 1);
        }
        this.selectedUsersChange.emit(this.selectedUsers);
    }

    private getUserIdIdx(user: ILightWeightUserWithUnits): number {
        return this.selectedUsers.findIndex((selectedUser) => user.Id === selectedUser.Id);
    }
}
